

/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

// Shared cart notification — reuses the wishlist toast element already in layout/theme.liquid.
// Avoids native alert() dialogs for all cart error paths.
var _hovCartToastTimer;
function hovShowCartToast(message) {
  var toast      = document.getElementById('hov-wish-toast');
  var toastTitle = document.getElementById('hov-wish-toast-title');
  var toastSub   = document.getElementById('hov-wish-toast-sub');
  var toastImg   = document.getElementById('hov-wish-toast-img');
  var toastClose = document.getElementById('hov-wish-toast-close');
  if (!toast) return;

  toast.classList.remove('show');
  void toast.offsetWidth; // force reflow so CSS animation restarts

  toastTitle.textContent = 'Cart update failed';
  toastSub.textContent   = message || 'Please try again.';
  if (toastImg) toastImg.style.display = 'none';

  toast.classList.add('show');
  clearTimeout(_hovCartToastTimer);
  _hovCartToastTimer = setTimeout(function() { toast.classList.remove('show'); }, 3500);
  if (toastClose) {
    toastClose.onclick = function() {
      clearTimeout(_hovCartToastTimer);
      toast.classList.remove('show');
    };
  }
}

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
   //alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    hovShowCartToast(data.message);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  return jQuery.ajax(params); // return jqXHR so callers can call .abort()
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body, quantityDebounceTimers = {}, originalQuantities = {}, inflightRequests = {};

  // Expose the free-shipping threshold globally (from Liquid, once).
  // Modal warning math reads this — never hardcoded a second time.
  window.hovFreeShippingThreshold = 399;

  // Stores the last authoritative cart payload so the modal can read the current
  // subtotal synchronously without an extra /cart.js fetch.
  var _lastCartPayload = null;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty, renderMiniCart, renderAllSurfaces;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : '.enj-add-to-cart-btn',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled.
    // Delegated (see formOverride), so no add buttons need to exist at init time.
    if (!settings.disableAjaxCart) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();

    // Reverse sync: when the /cart page mutates the cart, it broadcasts the fresh payload
    // and we rebuild the drawer from it (the /cart page refreshes its own section).
    document.addEventListener('hov:cart:mutated', function (e) {
      if (e && e.detail && e.detail.cart) {
        renderMiniCart(e.detail.cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: e.detail.cart } }));
      }
    });

    // Eagerly populate _lastCartPayload on init so the remove-modal's
    // savings warning math works even before the first AJAX rebuild.
    if (!_lastCartPayload) {
      ShopifyAPI.getCart(function(cart) {
        _lastCartPayload = cart;
      });
    }
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    // Re-query live every time. The mini-cart region is rebuilt by buildCart(), so any
    // jQuery reference cached at init() points at detached nodes after the first rebuild
    // (this was the frozen-subtotal bug). Querying here keeps header + drawer in sync.
    $('.enj-cartcount').html(cart.item_count).removeClass('hidden-count');
    $('.product-popup').find('.product-item-count').html(cart.item_count);
    if (cart.item_count === 0) {
      $('.enj-cartcount').addClass('hidden-count');
      $('.js-number-cart').removeClass('active');
    }
    // Subtotal = sum of line totals (before order-level discounts); Total = after all discounts.
    // Driven straight from the authoritative payload — never summed client-side.
    $('[data-cart-subtotal]').html(Shopify.formatMoney(cart.items_subtotal_price, settings.moneyFormat));
    // total_price is already net of every discount Shopify has applied (coupons go through
    // /cart/update.js in assets/hov-coupons.js), so it is written straight through.
    $('.enj-cartcost').html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));

    // Discount row: shown whenever Shopify reports a real order-level discount (automatic or code).
    // Subtotal − Total, so the three rows always reconcile; total_discount would double-count
    // line-level discounts that items_subtotal_price already reflects.
    var $discountRow = $('[data-cart-discount]');
    if ($discountRow.length) {
      var discountCents = Math.max(0, cart.items_subtotal_price - cart.total_price);
      if (discountCents > 0) {
        $('[data-cart-discount-amount]').html('− ' + Shopify.formatMoney(discountCents, settings.moneyFormat));
        $discountRow.removeAttr('hidden');
      } else {
        $discountRow.attr('hidden', 'hidden');
      }
    }
  };

  // Re-render the mini-cart drawer entirely from one authoritative cart payload.
  // This is the SINGLE source of truth for the drawer — no field is ever patched
  // independently of this path, so the surfaces can't drift apart.
  renderMiniCart = function (cart) {
    updateCountPrice(cart);
    buildCart(cart);
  };

  // Re-render every cart surface currently on the page from the same payload.
  // The /cart page is a real section, so it's refreshed via the Section Rendering API
  // (window.hovRenderPageCartSection, defined by sections/page-cart.liquid when present).
  renderAllSurfaces = function (cart) {
    renderMiniCart(cart);
    if (typeof window.hovRenderPageCartSection === 'function') {
      window.hovRenderPageCartSection();
    }
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
  };

  // Exposed so off-drawer surfaces (e.g. the /cart page's "You may also like" carousel "+ Add")
  // can refresh every cart surface through the SAME path instead of re-implementing a render.
  window.renderAllSurfaces = function (cart) { renderAllSurfaces(cart); };

  formOverride = function () {
    // Delegated + guarded: catches EVERY /cart/add form submit — including grid cards re-rendered
    // after init by collection.js (filter/sort/infinite-scroll) and card variants whose button is
    // not .enj-add-to-cart-btn — without double-firing on bespoke add handlers that already
    // preventDefault (quickview uses type="button"; complementary-products preventDefaults its own).
    $body.on('submit', 'form[action^="/cart/add"]', function(evt) {
      if (evt.isDefaultPrevented()) return;
      evt.preventDefault();
      var $addToCart_btn = $(this).find('button[type="submit"][name="add"], ' + settings.addToCartSelector);
      // Add class to be styled if desired
      $addToCart_btn.removeClass('is-added').addClass('is-adding');
      $addToCart_btn.find("i").replaceWith('<i class="enj-loader-add-to-cart fsz-unset"><svg xml:space="preserve" style="enable-background:new 0 0 50 50;margin-top: -1px;" viewBox="0 0 24 30" height="20px" width="21px" y="0px" x="0px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" id="Layer_1" version="1.1"><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="0"><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="8">      <animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="16"><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect></svg></i>');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product, form) {
    var $addToCart_btn = $(form).find(settings.addToCartSelector);
    $addToCart_btn.removeClass('is-adding').addClass('is-added');
    $addToCart_btn.find('.enj-loader-add-to-cart').html('<svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400" height="400" width="400" xml:space="preserve" id="svg2" version="1.1"><metadata id="metadata8"><rdf:RDF><cc:Work rdf:about=""><dc:format>image/svg+xml</dc:format><dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage"/></cc:Work></rdf:RDF></metadata><defs id="defs6"/><g transform="matrix(1.3333333,0,0,-1.3333333,0,400)" id="g10"><g transform="scale(0.1)" id="g12"><path id="path14" style="/* fill:#231f20; */fill-opacity:1;fill-rule:nonzero;stroke:none;" d="M 2539.18,1385.02 C 2479.15,849.23 2004.9,434.289 1446.39,470.129 931.406,503.16 516.711,917.871 483.672,1432.85 c -38.359,597.88 439.844,1099.19 1029.878,1099.19 78.39,0 149.09,-7.24 218.27,-21.98 42.37,-9.03 86.4,4.1 116.99,34.78 v 0 c 71.82,72.04 34.9,194.92 -64.67,215.74 -88.86,18.58 -179.73,29.87 -270.59,29.87 -709.417,0 -1290.445,-581.02 -1290.445,-1290.45 0,-709.418 581.028,-1290.449 1290.445,-1290.449 661.24,0 1210.92,504.781 1282.54,1147.799 8.47,76.02 -50.73,142.65 -127.21,142.65 h -2.45 c -65.64,0 -119.94,-49.75 -127.25,-114.98 z M 894.004,1654.48 v 0 c -49.668,-49.89 -49.578,-130.58 0.207,-180.36 L 1384.35,983.98 2584.51,2184.15 c 49.87,49.87 49.87,130.71 0,180.57 l -0.23,0.23 c -49.88,49.87 -130.74,49.85 -180.6,-0.03 L 1384.35,1344.99 1074.79,1654.67 c -49.94,49.95 -130.95,49.87 -180.786,-0.19"/></g></g></svg>');

    $('.product-popup').find('.product-name').html(product.title);  
    $('.product-popup').find('.product-price').html(Shopify.formatMoney(product.price, settings.moneyFormat)); 
    $('.product-popup').find('.product-qty').html(product.quantity,); 
                                                  $('.product-popup').find('.product-total').html(Shopify.formatMoney(product.line_price, settings.moneyFormat)); 


    $('.product-popup').find('.product-image img').attr('src', product.image);

    // Open the mini-cart drawer (reuses the existing .js-minicart / .bg-minicart open mechanism
    // from engo-scripts.js) instead of the old .product-popup. getCart() below rebuilds its contents.
    $('.js-minicart, .bg-minicart').addClass('active');

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');
    $addToCart.find('.enj-loader-add-to-cart').remove();

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Add-to-cart and initial load: rebuild the drawer from the payload, then let
    // dependent UI (coupon tickets, etc.) react to the fresh cart.
    renderMiniCart(cart);
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $('.hov-cart-shipping').hide();
      $('.hov-cart__mini-trust').hide();
      $('.hov-cart__promo-strip').hide();
      $cartContainer
      .append('<div class="hov-cart-empty"><p>' + "Your shopping bag is empty" + '</p><a href="/products/negativity-removal-cleansing-bar">' + "Go to the shop" + '</a></div>');
      cartCallback(cart);
      $('.js-number-cart').removeClass('active');
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      // Create item's data object and add to 'items' array
      item = {
        id: cartItem.variant_id,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: (function() {
          var v = cartItem.variant_title;
          if (!v) return null;
          var vTrimmed = v.replace(/^\s+|\s+$/g, '').toLowerCase();
          if (v.indexOf('Default') > -1 || vTrimmed === 'pack of 1' || vTrimmed.indexOf('pack of 1') > -1) {
            return null;
          }
          return v;
        })(),
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.final_line_price, settings.moneyFormat),
        comparePrice: (function() {
          // Line-total scale to match the line-total main price (final_line_price).
          if (cartItem.compare_at_price > cartItem.price) {
            return Shopify.formatMoney(cartItem.compare_at_price * cartItem.quantity, settings.moneyFormat);
          } else if (cartItem.original_line_price > cartItem.final_line_price) {
            return Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat);
          }
          return null;
        })(),
        vendor: cartItem.vendor,
        productId: cartItem.product_id,
        lineTotal: cartItem.final_line_price
      };

      items.push(item);
    });

    // Basis is the subtotal BEFORE coupons (see snippets/hov-free-shipping-bar.liquid).
    var threshold = 399 * 100;
    var remainingCents = threshold - cart.items_subtotal_price;
    if (remainingCents < 0) remainingCents = 0;
    var progressPercent = (cart.items_subtotal_price * 100.0) / threshold;
    if (progressPercent > 100) progressPercent = 100;

    // Update free shipping bar (Region A is outside dynamic content)
    var showPromoStrip = true;
    if (cart.item_count > 0) {
      $('.hov-cart-shipping').show();
      $('.hov-cart__mini-trust').show();
      if (showPromoStrip) {
        $('.hov-cart__promo-strip').show();
      } else {
        $('.hov-cart__promo-strip').hide();
      }
      if (remainingCents === 0) {
        $('.hov-cart-shipping-text').text("🎉 You've unlocked FREE shipping!");
      } else {
        $('.hov-cart-shipping-text').text("You are " + Shopify.formatMoney(remainingCents, settings.moneyFormat) + " away from FREE shipping!");
      }
      $('.hov-cart-shipping-fill').css('width', progressPercent + '%');
    } else {
      $('.hov-cart-shipping').hide();
      $('.hov-cart__mini-trust').hide();
      $('.hov-cart__promo-strip').hide();
    }

    // Gather all cart data and add to DOM. The Discount row and Total are rendered here, at build
    // time, because this rebuild wipes anything updateCountPrice() wrote into the drawer earlier.
    var discountCents = Math.max(0, cart.items_subtotal_price - cart.total_price);
    data = {
      items: items,
      note: cart.note,
      subtotalPrice: Shopify.formatMoney(cart.items_subtotal_price, settings.moneyFormat),
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      hasDiscount: discountCents > 0,
      discountAmount: Shopify.formatMoney(discountCents, settings.moneyFormat),
      remainingAmount: Shopify.formatMoney(remainingCents, settings.moneyFormat),
      isFreeShipping: remainingCents === 0,
      progressPercent: progressPercent,
      threshold: 399,
      trust1Label: "100% Secure Payments",
      trust2Label: "Easy Returns & Refunds",
      trust3Label: "Authentic Handmade Soap"
    }
    $('.product-popup').find('.product-total-cart').html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));

    $cartContainer.append(template(data));

    // Store the authoritative cart payload for modal savings math.
    _lastCartPayload = cart;

    cartCallback(cart);
    $('.js-number-cart').addClass('active');
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('ajaxCart.afterCartLoad', cart);
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      var $el = $(this),
          line = $el.data('line');

      if (!line) return;

      var $itemRow = $el.closest('.hov-cart-item');
      var $qtyInput = $itemRow.find('.ajaxcart__qty-num');
      var currentQty = parseInt($qtyInput.text().replace(/\D/g, ''));
      currentQty = isNaN(currentQty) ? 1 : currentQty;

      // Keep track of the original quantity before any changes if not already set
      if (originalQuantities[line] === undefined) {
        originalQuantities[line] = currentQty;
      }

      // Calculate target quantity
      var targetQty = currentQty;
      if ($el.hasClass('ajaxcart__qty--plus')) {
        targetQty += 1;
      } else {
        targetQty -= 1;
        if (targetQty < 0) targetQty = 0;
      }

      // Optimistic update in DOM
      $qtyInput.text(targetQty);

      // Debounce the updateQuantity call
      if (quantityDebounceTimers[line]) {
        clearTimeout(quantityDebounceTimers[line]);
      }

      quantityDebounceTimers[line] = setTimeout(function() {
        // Disable buttons for this specific line in-flight
        $itemRow.find('.hov-cart-item-qty button').css({
          'pointer-events': 'none',
          'opacity': '0.5'
        });

        updateQuantityOptimistic(line, targetQty, $itemRow);
      }, 300);
    });

    // ── Delete: open confirmation modal instead of immediate removal ──
    $body.on('click', '.remove-product', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var $el = $(this),
          line = $el.data('line');
      if (!line) return;

      var $itemRow = $el.closest('.hov-cart-item');
      hovOpenRemoveModal(line, $itemRow);
    });

    // ── Remove-modal: open with per-product context ──
    function hovOpenRemoveModal(line, $itemRow) {
      var modal = document.getElementById('hov-remove-modal');
      if (!modal) return;

      // Surface-aware positioning: the shared modal lives inside the (off-screen-when-closed) drawer,
      // so on the full /cart page it must center on the viewport instead of the drawer box.
      // Rewritten on every open, so there is no stale-context bleed between the two surfaces.
      modal.dataset.context = ($itemRow && $itemRow.closest('.hov-cart-page').length) ? 'cart-page' : 'minicart';

      var productId = $itemRow.data('productId') || $itemRow.attr('data-product-id');
      var productTitle = $itemRow.find('.hov-cart-item-title').text().trim();
      var productImg = $itemRow.find('.hov-cart-item-img').attr('src') || '';
      var productPrice = $itemRow.find('.hov-cart-item-price').text().trim();

      // Populate title
      modal.querySelector('#hov-remove-modal-title').textContent =
        'Are you sure you want to remove this item?';

      // Subtitle — always honest, generic copy
      modal.querySelector('[data-remove-subtitle]').textContent =
        'This product is a customer favorite and frequently bought together.';

      // Populate removing item preview
      var itemImgEl = modal.querySelector('[data-remove-item-img]');
      if (itemImgEl) itemImgEl.src = productImg;
      var itemNameEl = modal.querySelector('[data-remove-item-name]');
      if (itemNameEl) itemNameEl.textContent = productTitle;
      var itemPriceEl = modal.querySelector('[data-remove-item-price]');
      if (itemPriceEl) itemPriceEl.textContent = productPrice;

      // Store the line + $itemRow reference on the modal for the confirm handler
      modal._hovRemoveLine = line;
      modal._hovRemoveItemRow = $itemRow;

      // Cross-sell: fetch from Shopify's native Recommendations API
      var crosssellEl = modal.querySelector('[data-remove-crosssell]');
      crosssellEl.hidden = true; // hide until we have real data

      if (productId) {
        fetch('/recommendations/products.json?product_id=' + productId + '&limit=4&intent=complementary')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var products = data.products || [];

            // Filter out products already in the cart
            var cartItemIds = [];
            if (_lastCartPayload && _lastCartPayload.items) {
              _lastCartPayload.items.forEach(function(ci) {
                cartItemIds.push(ci.product_id);
              });
            }
            var filtered = products.filter(function(p) {
              return cartItemIds.indexOf(p.id) === -1;
            });

            if (filtered.length > 0) {
              var rec = filtered[0];
              crosssellEl.hidden = false;
              modal.querySelector('[data-remove-crosssell-img]').src = rec.featured_image || '';
              modal.querySelector('[data-remove-crosssell-img]').alt = rec.title;
              modal.querySelector('[data-remove-crosssell-headline]').textContent = 'Complete your health journey!';
              modal.querySelector('[data-remove-crosssell-desc]').textContent =
                'Customers often pair this with ' + rec.title;

              // Store the variant ID for the "Add Now" button
              var addBtn = modal.querySelector('[data-remove-crosssell-add]');
              addBtn.disabled = false;
              addBtn._hovCrosssellVariantId = rec.variants && rec.variants[0] ? rec.variants[0].id : null;
              addBtn._hovCrosssellTitle = rec.title;
            }
          })
          .catch(function() {
            // Silently hide cross-sell on error — never show broken/empty state
            crosssellEl.hidden = true;
          });
      }

      // Evaluate savings warning
      hovEvaluateRemovalWarning(line, $itemRow, modal);

      // Show the modal
      modal.dataset.state = 'visible';
      document.body.style.overflow = 'hidden';
    }

    // ── Conditional savings warning — only when threshold math says it's true ──
    function hovEvaluateRemovalWarning(line, $itemRow, modal) {
      var warningEl = modal.querySelector('[data-remove-warning]');
      var warningText = modal.querySelector('[data-remove-warning-text]');

      // Default: hidden
      warningEl.hidden = true;

      // Get current cart subtotal from last authoritative payload
      if (!_lastCartPayload) return;
      // Free-shipping basis: the subtotal before coupons (snippets/hov-free-shipping-bar.liquid).
      var currentSubtotalCents = _lastCartPayload.items_subtotal_price; // in cents

      // Get this line item's total from the data attribute (in cents)
      var lineTotalCents = parseInt($itemRow.attr('data-line-total'), 10);
      if (isNaN(lineTotalCents)) return;

      var projectedCents = currentSubtotalCents - lineTotalCents;
      var thresholdCents = window.hovFreeShippingThreshold * 100;

      // Only show warning when removing this item would CROSS the threshold. Emptying the cart is
      // not "losing" free shipping, so removing the last item never warns.
      if (currentSubtotalCents >= thresholdCents && projectedCents < thresholdCents && projectedCents > 0) {
        warningEl.hidden = false;
        warningText.innerHTML =
          'Removing this item will drop you below ' + Shopify.formatMoney(thresholdCents, settings.moneyFormat) +
          ' — you\u2019ll <strong>lose free shipping</strong>.';
      }
    }

    // ── Close modal helper ──
    function hovCloseRemoveModal() {
      var modal = document.getElementById('hov-remove-modal');
      if (modal) {
        modal.dataset.state = 'hidden';
        document.body.style.overflow = '';
        modal._hovRemoveLine = null;
        modal._hovRemoveItemRow = null;
      }
    }

    // ── Modal close handlers ("Keep It", overlay click, × button) — zero network requests ──
    $body.on('click', '[data-remove-modal-close]', function(e) {
      e.preventDefault();
      hovCloseRemoveModal();
    });

    // Close on Escape key
    $(document).on('keydown', function(e) {
      if (e.key === 'Escape') {
        var modal = document.getElementById('hov-remove-modal');
        if (modal && modal.dataset.state === 'visible') {
          hovCloseRemoveModal();
        }
      }
    });

    // ── "Remove Item" — calls the existing shared pipeline ──
    $body.on('click', '[data-remove-confirm]', function(e) {
      e.preventDefault();
      var modal = document.getElementById('hov-remove-modal');
      if (!modal || !modal._hovRemoveLine) return;

      var line = modal._hovRemoveLine;
      var $itemRow = modal._hovRemoveItemRow;

      // Disable button to prevent double-clicks
      var confirmBtn = modal.querySelector('[data-remove-confirm]');
      if (confirmBtn) confirmBtn.disabled = true;

      // Cancel any pending debounce for this line
      if (quantityDebounceTimers[line]) {
        clearTimeout(quantityDebounceTimers[line]);
      }

      // Disable qty buttons on the row (visual feedback)
      if ($itemRow && $itemRow.length) {
        $itemRow.find('.hov-cart-item-qty button').css({
          'pointer-events': 'none',
          'opacity': '0.5'
        });
      }

      // Close modal immediately, then fire the removal through the shared pipeline
      hovCloseRemoveModal();

      // Re-enable the button for next use (modal is now hidden, so no visual glitch)
      if (confirmBtn) confirmBtn.disabled = false;

      // Same updateQuantityOptimistic path as the quantity stepper — no parallel code
      updateQuantityOptimistic(line, 0, $itemRow || $('<div>'));
    });

    // ── Cross-sell "Add Now" — uses the shared cart pipeline ──
    $body.on('click', '[data-remove-crosssell-add]', function(e) {
      e.preventDefault();
      var addBtn = this;
      var variantId = addBtn._hovCrosssellVariantId;
      if (!variantId) return;

      addBtn.disabled = true;
      addBtn.textContent = 'Adding...';

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        contentType: 'application/json',
        dataType: 'json',
        success: function() {
          addBtn.textContent = 'Added ✓';
          // Refresh cart via the shared pipeline
          ShopifyAPI.getCart(function(cart) {
            renderAllSurfaces(cart);
          });
          // Reset button after a moment
          setTimeout(function() {
            addBtn.textContent = 'Add Now';
            addBtn.disabled = false;
          }, 2000);
        },
        error: function() {
          addBtn.textContent = 'Add Now';
          addBtn.disabled = false;
          hovShowCartToast('Could not add item — please try again.');
        }
      });
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantityOptimistic(line, qty, $itemRow) {
      isUpdating = true;

      // Abort any previous in-flight request for this same line item before firing a new one.
      // jQuery's jqXHR has .abort(); aborting triggers the error callback with textStatus='abort'.
      if (inflightRequests[line]) {
        inflightRequests[line].abort();
      }

      inflightRequests[line] = ShopifyAPI.changeItem(line, qty, function(cart) {
        delete inflightRequests[line];
        isUpdating = false;
        delete originalQuantities[line];
        delete quantityDebounceTimers[line];

        // One authoritative re-render of every surface from this single payload.
        // buildCart() rebuilds the drawer (incl. line prices, subtotal/total and the
        // free-shipping bar), so there is no per-field patching left to drift.
        renderAllSurfaces(cart);
      }, function(xhr, textStatus) {
        delete inflightRequests[line];

        // 'abort' means this request was superseded by a newer click — not a real failure, ignore silently.
        if (textStatus === 'abort') return;

        isUpdating = false;
        delete quantityDebounceTimers[line];

        // Re-enable buttons
        $itemRow.find('.hov-cart-item-qty button').css({
          'pointer-events': '',
          'opacity': ''
        });

        // Revert optimistic display to the last confirmed server quantity
        if (originalQuantities[line] !== undefined) {
          $itemRow.find('.ajaxcart__qty-num').text(originalQuantities[line]);
          $itemRow.find('.ajaxcart__qty--minus').attr('data-qty', originalQuantities[line] - 1);
          $itemRow.find('.ajaxcart__qty--plus').attr('data-qty', originalQuantities[line] + 1);
          delete originalQuantities[line];
        }

        hovShowCartToast('Could not update quantity — please try again.');
      });
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    isUpdating = false;

    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
          console.log(qty);
          updatePricingQty(qty);
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
          updatePricingQty(qty);
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));
